import React from 'react';
import { createRoot } from 'react-dom/client';
import { ensureYandexMetrikaStub } from '@utils/lib/yandexMetrika';

import {App} from './app';

ensureYandexMetrikaStub();

createRoot(document.getElementById('root')).render(
	// StrictMode отключён: react-input-mask (маски телефона во всех формах)
	// использует findDOMNode, deprecated в React 18 — под StrictMode это шлёт
	// предупреждения в консоль. После миграции масок на современную библиотеку
	// можно вернуть обратно.
	<App />,
)
